module.exports = __webpack_public_path__ + "static/img/avatar-placeholder.8d17db1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatar-placeholder.png
// module id = fgNM
// module chunks = 1